"use client";

import { ContainerTextFlip } from "@/components/ui/container-text-flip";

const FLIP_WORDS = ["Chatbots", "Websites", "Workflows", "Agents"];

export function HeroHeading() {
  return (
    <h1 className="max-w-4xl font-heading text-4xl tracking-tight sm:text-5xl md:text-6xl lg:text-[4.5rem] lg:leading-[1.15]">
      Ship smarter with{" "}
      <span className="text-gradient">AI</span>
      <br className="hidden sm:block" />
      {" "}Build your{" "}
      <ContainerTextFlip
        words={FLIP_WORDS}
        interval={2500}
        className="text-3xl sm:text-4xl md:text-5xl lg:text-[3.5rem]"
        textClassName="font-heading text-white"
        animationDuration={600}
      />
    </h1>
  );
}
